exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inputContainer__CompanySpecificField-module___1NSiY {\n  width: 100%;\n  margin-bottom: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"inputContainer": "inputContainer__CompanySpecificField-module___1NSiY"
};